export default __webpack_public_path__ + "static/media/fullscreen.12ff5fe2.svg";